<template>
  <nav class="nav-container" id="nav">
    <div class="nav-desktop">
      <div class="nav-start">
        <router-link to="/availability" class="nav-link">Availability</router-link>
        <router-link to="/#qualifications" class="nav-link">Qualifications</router-link>
        <router-link to="/faq" class="nav-link">FAQ</router-link>
      </div>
      <div class="nav-center">
        <div class="nav-logo">
          <router-link to="/">
            <img :src="logoSrc" :alt="logoAlt" />
          </router-link>
        </div>
      </div>
      <div class="nav-end">
        <router-link to="/#animal-policy" class="nav-link">Animal Policy</router-link>
        <div @click="toggleResidentResources" class="nav-button">
          <span class="nav-link">Resident Resources</span>
          <span class="material-symbols-outlined"> arrow_drop_down </span>
        </div>
      </div>
    </div>

    <div class="nav-mobile">
      <div class="nav-logo">
        <router-link to="/">
          <img :src="logoSrc" :alt="logoAlt" />
        </router-link>
      </div>
      <span class="material-symbols-outlined menu-btn" @click="showMobileMenu = !showMobileMenu"> menu </span>
    </div>

    <Transition
      name="mobile"
      @beforeEnter="clearHeight"
      @beforeLeave="setHeight"
      @enter="setHeight"
      @leave="clearHeight">
      <div v-if="showMobileMenu" class="mobile-menu">
        <div class="mobile-menu-btns">
          <router-link to="/availability" class="nav-link" @click="showMobileMenu = false">Availability</router-link>
          <router-link to="/#qualifications" class="nav-link" @click="showMobileMenu = false"
            >Qualifications</router-link
          >
          <router-link to="/faq" class="nav-link" @click="showMobileMenu = false"> FAQ </router-link>
          <router-link to="/#animal-policy" class="nav-link" @click="showMobileMenu = false">Animal Policy</router-link>
          <div @click="toggleResidentResources" id="mobileResources" class="nav-button">
            <span class="nav-link">Resident Resources</span>
            <span class="material-symbols-outlined"> arrow_drop_down </span>
          </div>
        </div>
      </div>
    </Transition>
    <div id="incentive" v-if="bannerTitle">
      <p class="sub-title" v-if="bannerSubtitle">{{ bannerSubtitle }}</p>
      <p class="title">{{ bannerTitle }}</p>
      <router-link to="/availability" class="nav-link">
        <span v-if="bannerCTA">{{ bannerCTA }}</span>
      </router-link>
    </div>
  </nav>

  <OverlayPanel ref="residentResources">
    <div class="resources">
      <a
        href="https://maxxpm.appfolio.com/connect/users/sign_in"
        target="_blank"
        @click="toggleResidentResources"
        class="nav-link">
        Resident Portal
      </a>
      <a
        href="https://form.jotform.com/230294998073063"
        target="_blank"
        @click="toggleResidentResources"
        class="nav-link">
        Animal Addition/Removal
      </a>
      <a
        href="https://form.jotform.com/230295437369060"
        target="_blank"
        @click="toggleResidentResources"
        class="nav-link">
        Resident Removal
      </a>
      <a
        href="https://form.jotform.com/231424875857063"
        target="_blank"
        @click="toggleResidentResources"
        class="nav-link">
        Resident Addition
      </a>
      <a
        href="https://form.jotform.com/231424826779163"
        target="_blank"
        @click="toggleResidentResources"
        class="nav-link">
        Resident Replacement
      </a>
      <a
        href="https://form.jotform.com/231417133431040"
        target="_blank"
        @click="toggleResidentResources"
        class="nav-link">
        Lease Termination
      </a>
    </div>
  </OverlayPanel>
</template>

<script setup>
import { ref } from "vue";
import OverlayPanel from "primevue/overlaypanel";

//eslint-disable-next-line
const props = defineProps({
  logoSrc: {
    type: String,
    required: true,
  },
  logoAlt: {
    type: String,
    required: true,
  },
  bannerTitle: {
    type: String,
    required: false,
  },
  bannerSubtitle: {
    type: String,
    required: false,
  },
  bannerCTA: {
    type: String,
    required: false,
  },
});

const residentResources = ref(null);

function toggleResidentResources(e) {
  residentResources.value.toggle(e);
  checkMobileMenu(e);
}

const showMobileMenu = ref(false);

function checkMobileMenu(e) {
  if (e.target.parentNode.id !== "mobileResources" && showMobileMenu.value) {
    showMobileMenu.value = false;
  }
}

function clearHeight(el) {
  el.style.height = "0";
}

function setHeight(el) {
  el.style.height = el.scrollHeight + "px";
}
</script>

<style scoped lang="scss">
$nav-height: 125px;

.nav-link {
  color: var(--primary-color);
  text-decoration: none;
  padding: 0.5rem 0.75rem;
}

.nav-link:hover {
  text-decoration: underline;
}

.nav-button {
  display: flex;
  align-items: center;
  color: var(--primary-color);
  padding: 0.5rem 0.75rem;
  .nav-link {
    padding: 0;
  }
}

.nav-button:hover {
  .nav-link {
    text-decoration: underline;
  }
}

.nav-button {
  cursor: pointer;
}
.nav-container {
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.07), 0 2px 4px rgba(0, 0, 0, 0.05);
  position: sticky;
  top: 0;
  z-index: 99;
  width: 100%;
  background: #eee;
}
.nav-desktop {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 1rem 0;
}

.nav-mobile,
.mobile-menu {
  display: none;
}

.nav-center {
  flex: 0 0 275px;
}

.nav-start,
.nav-end {
  flex: 0 0 calc((100vw - 275px) / 2);
}

.nav-logo {
  max-width: 275px;
  margin: auto;
  max-height: $nav-height;
  padding: 0 1rem;
}

.nav-logo > a > img {
  width: 100%;
  max-height: $nav-height;
  object-fit: contain !important;
}

.nav-logo > img:hover {
  cursor: pointer;
}

.nav-start,
.nav-end {
  display: flex;
  align-items: center;
}

.nav-start {
  justify-content: flex-end;
}

.resources {
  display: flex;
  flex-direction: column;
}

#incentive {
  padding: 1rem;
  background-color: var(--secondary-color);
  color: inherit;
  font-weight: 800;
  border-top: 1px solid var(--primary-color);
  border-bottom: 1px solid var(--primary-color);
  display: flex;
  align-items: center;
  justify-content: center;

  .title {
    font-size: 20px;
    text-align: center;
  }

  .sub-title {
    font-size: 14px;
  }

  .title,
  .sub-title {
    margin: 0 1rem;
  }

  button {
    padding: 0 1rem;
  }
}

@media (max-width: 875px) {
  .nav-desktop {
    display: none;
  }

  .nav-mobile {
    display: flex;
    padding: 1rem 0;
    justify-content: space-between;
    align-items: center;
  }

  .nav-logo {
    max-width: 60vw;
    margin: 0;
  }

  .menu-btn {
    margin-right: 1.5rem;
    color: var(--primary-color);
  }

  .mobile-menu {
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
    transition: 0.5s ease-in-out;
    padding-bottom: 1rem;
  }

  .mobile-menu-btns {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  #incentive {
    flex-direction: column;
    align-items: center;

    .title {
      padding: 0.5rem 0;
    }
  }
}
</style>
